import { DragDropModule } from '@angular/cdk/drag-drop';
import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule, CurrencyPipe } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { RouterModule, Routes } from '@angular/router';
import { ComponentModule } from '@app/component/component.module';
import { MoneybarLegendComponent } from '@app/component/moneybar-legend/moneybar-legend';
import { MoneybarSidepanelComponent } from '@app/component/moneybar-sidepanel/moneybar-sidepanel.component';
import { isAuthenticatedGuard } from '@app/core/guard/is-authenticated.guard';
import { MoneybarComponent } from '@app/funding/moneybar/moneybar.component';
import { MoneybarContainerComponent } from '@app/funding/moneybar-container/moneybar-container.component';
import { Permissions } from '@core/constants/permissions';
import { CandidateGroupForMoneybarResolver } from '@shared/funding/candidate-group-for-moneybar.resolver';
import { SettingGroup } from '@shared/setting/setting-group.enum';
import { SettingListResolver } from '@shared/setting/setting-list-resolver.service';
import { SharedModule } from '@shared/shared.module';

import { MoneybarConfigComponent } from './moneybar-config/moneybar-config.component';

const routes: Routes = [
  {
    path: 'moneybar',
    component: MoneybarConfigComponent,
    resolve: {
      settings: SettingListResolver,
      allRelevantGroups: CandidateGroupForMoneybarResolver,
    },
    canActivate: [isAuthenticatedGuard],
    data: {
      settingGroup: SettingGroup.MONEYBAR,
      roles: [Permissions.ROLE_LEVEL_20],
      rolesToEdit: [Permissions.ROLE_LEVEL_60],
    },
  },
];

@NgModule({
  declarations: [
    MoneybarComponent,
    MoneybarConfigComponent,
    MoneybarContainerComponent,
    MoneybarLegendComponent,
    MoneybarSidepanelComponent,
  ],
  exports: [MoneybarComponent, MoneybarContainerComponent, MoneybarLegendComponent, MoneybarSidepanelComponent],
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    MatProgressBarModule,
    SharedModule,
    ReactiveFormsModule,
    ComponentModule,
    DragDropModule,
    OverlayModule,
  ],
  providers: [CurrencyPipe],
})
export class FundingModule {}
